import React, {ReactNode} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import './observation-card.scss';

export type ObservationCardLink = {
    label: string,
    to: string
}

export type ObservationCardProps = {
    kicker?: string|ReactNode,
    title?: string|ReactNode,
    copy?: string|ReactNode,
    image?: string
    badges?: string[],
    familyLink?: ObservationCardLink,
    sourceUrl?: string
}

const getBadgeClassName = (badge: string) => {
    const modifier = badge.toLowerCase().replace(/\s+/g, '-');
    return `observation-card__badge observation-card__badge--${modifier}`;
}

export function ObservationCard({kicker, title, copy, image, badges = [], familyLink, sourceUrl}: ObservationCardProps) {
    const renderBadgeContent = (badge: string) => (
        <>
            {badge.toLowerCase() === 'lifer' ?
                <FontAwesomeIcon icon={faStar} aria-hidden="true" />
                : null
            }
            {badge}
        </>
    );

    return (
        <div className="observation-card">
            {image ?
                <div className="observation-card__img">
                    <img src={image} alt={typeof title === 'string' ? title : ''} />
                    <div className="observation-card__image-content">
                        {sourceUrl ?
                            <a className="observation-card__source-link" href={sourceUrl} target="_blank" rel="noreferrer">eBird</a>
                            : null
                        }
                    </div>
                </div>
                : null
            }
            {(kicker || title || copy) ?
                <div className="observation-card__body">
                    {kicker ?
                        <div className="observation-card__kicker">{kicker}</div>
                        : null
                    }
                    {familyLink ?
                        <Link className="observation-card__family-link" to={familyLink.to}>
                            {familyLink.label}
                        </Link>
                        : null
                    }
                    {title ?
                        <div className="observation-card__title">{title}</div>
                        : null
                    }
                    {copy ?
                        <div className="observation-card__copy">{copy}</div>
                        : null
                    }
                </div> : null
            }
            {badges.length ?
                <div className="observation-card__badges" aria-label="Observation highlights">
                    {badges.map(badge => (
                        <span className={getBadgeClassName(badge)} key={badge}>
                            {renderBadgeContent(badge)}
                        </span>
                    ))}
                </div>
                : null
            }
        </div>
    )
}
